import { Descriptions } from 'antd';
import type { TimeInTransitSourcePreference } from '~/store/simulation/types';
import { TNT_MODEL_SOURCE_MAPPING, TNT_SETTING_MAPPING, TNT_SOURCE_PREFERENCE_MAPPING } from '~/store/simulation/types';
import type { Partner } from '~/store/services/PartnerService/types';

export const TntOptionsConfiguration = ({
  activePartner,
  isAdmin = true,
}: {
  activePartner?: Partner;
  isAdmin?: boolean;
}) => {
  const {
    timeInTransitModelSource,
    timeInTransitRoundingStrategy: timeInTransitSetting,
    timeInTransitSourcePreference,
  } = activePartner?.deliveryExperienceConfigurationInfo || {};

  const tntConfiguration: { label: string; value: React.ReactNode }[] = [];

  if (timeInTransitSourcePreference?.length) {
    tntConfiguration.push({
      label: 'TNT Source Preferences',
      value: (
        <ol
          style={{
            display: 'flex',
            flexWrap: 'wrap',
            listStylePosition: 'inside',
            paddingLeft: 0,
            margin: 0,
          }}
        >
          {timeInTransitSourcePreference?.map((source) => (
            <li key={source} style={{ marginRight: '14px' }}>
              {TNT_SOURCE_PREFERENCE_MAPPING[source as TimeInTransitSourcePreference]}
            </li>
          ))}
        </ol>
      ),
    });
  }

  if (isAdmin) {
    if (timeInTransitModelSource) {
      tntConfiguration.push({
        label: 'TNT Model Source',
        value: TNT_MODEL_SOURCE_MAPPING[timeInTransitModelSource],
      });
    }
    if (timeInTransitSetting) {
      tntConfiguration.push({
        label: 'TNT Setting',
        value: TNT_SETTING_MAPPING[timeInTransitSetting],
      });
    }
  }

  return tntConfiguration.length > 0 ? (
    <div style={{ marginBottom: '24px' }}>
      <h3>Production time in transit Configuration:</h3>
      <Descriptions layout="vertical" bordered size="small">
        {tntConfiguration.map(({ label, value }) => (
          <Descriptions.Item key={label} label={label} span={1}>
            {value}
          </Descriptions.Item>
        ))}
      </Descriptions>
    </div>
  ) : null;
};
